import { CAPACITY_UTILISATION } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  CapacityUtilisation: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const capacityUtilisationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CAPACITY_UTILISATION.REQUEST: {
      return { ...state, isLoading: true };
    }
    case CAPACITY_UTILISATION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        CapacityUtilisation: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case CAPACITY_UTILISATION.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default capacityUtilisationReducer;
